import { Grid } from "@mui/material";
import IssueReports from "./IssueReports";
import MaterialReports from "./MaterialReports";
import MemberReports from "./MemberReports";
import useAuth from "hooks/useAuth";
import IssueReturnPerformanceReports from "./IssueReturnPerformanceReports";

const Reports = () => {
  const { modules } = useAuth();
  return (
    <>
      <Grid container direction={"column"} gap={2} spacing={1}>
        {modules?.issueReturnReport.permissions.Add && (
          <Grid item>
            <IssueReports />
          </Grid>
        )}

        {modules?.materialReport.permissions.Add && (
          <Grid item>
            <MaterialReports />
          </Grid>
        )}

        {modules?.memberReport.permissions.Add && (
          <Grid item>
            <MemberReports />
          </Grid>
        )}

        {modules?.issueReturnPerfomanceReport.permissions.Add && (
          <Grid item>
            <IssueReturnPerformanceReports />
          </Grid>
        )}

      </Grid>
    </>
  );
};
export default Reports;
